// export DsfInternalMail from './internalMail.vue'
export const DsfInternalMail = dsf.defineAsyncComponent("DsfInternalMail", () => {
  return dsf.requestAsyncComponents($components.platform.DsfVirtualList).then(() => {
    return import(/*webpackChunkName:"platform_pc_homepage"*/ "./internalMail.vue");
  });
});
